/* Wishlist: localStorage-backed (same pattern as the OTP shadow session —
   no backend/app for this yet, but real add/remove/persist functionality
   instead of a dead "#" link). Saves product handles, not IDs — handles
   are what /products/{handle}.js needs to re-fetch full product data for
   the panel. */
document.addEventListener('DOMContentLoaded', function () {
  var STORAGE_KEY = 'vro_wishlist';

  function load() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }

  function save(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable, ignore */ }
  }

  function has(handle) { return load().indexOf(handle) !== -1; }

  function syncButtons() {
    var list = load();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-toggle');
      var active = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateCount() {
    var count = load().length;
    document.querySelectorAll('.wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function toggle(handle) {
    var list = load();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    save(list);
    syncButtons();
    updateCount();
    return i === -1; // true if it was just added
  }

  window.VroWishlist = { load: load, has: has, toggle: toggle, sync: syncButtons };

  syncButtons();
  updateCount();

  // Delegated so it works for every product card on the page (feed rails,
  // CLP grid, curation rails, PDP) without wiring each one individually.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-toggle');
    if (!handle) return;
    var added = toggle(handle);
    if (window.showToast) {
      showToast(added ? 'Added to wishlist' : 'Removed from wishlist', 'wishlist');
    }
  });

  // ---- Wishlist panel (same slide-in pattern as cart/profile/login) ----
  var panel = document.getElementById('wishlistPanel');
  var backdrop = document.getElementById('wishlistPanelBackdrop');
  if (!panel || !backdrop) return;

  var bodyEl = document.getElementById('wishlistPanelBody');
  var countEl = panel.querySelector('.wishlist-panel-count');
  var footEl = panel.querySelector('[data-wishlist-footer]');
  var addAllBtn = panel.querySelector('[data-wishlist-add-all]');
  var addAllNote = panel.querySelector('[data-wishlist-add-all-note]');
  var lastProducts = [];

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* The header's cart glyph (sections/header.liquid, the bag with the
     heart) without its 48px tile — this button draws its own — cropped
     to the glyph and inked with currentColor so it follows the button. */
  var CART_ICON =
    '<svg width="18" height="18" viewBox="12 12 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M33.5393 24.5966C33.1305 21.0939 32.5332 18.4676 31.9793 16.6017C31.5251 15.0717 31.298 14.3067 30.3667 13.6117C29.4355 12.9167 28.4836 12.9167 26.5799 12.9167H20.2536C18.3498 12.9167 17.3979 12.9167 16.4666 13.6117C15.5354 14.3067 15.3083 15.0717 14.8541 16.6017C14.3002 18.4676 13.7029 21.0939 13.2941 24.5966C12.8124 28.7247 12.5715 30.7888 13.9635 32.3527C15.3556 33.9167 17.6116 33.9167 22.1235 33.9167H24.7098"/>' +
      '<path d="M19.9167 17.5833C19.9167 19.5162 21.4837 21.0833 23.4167 21.0833C25.3497 21.0833 26.9167 19.5162 26.9167 17.5833"/>' +
      '<path d="M31 35.0833C31 35.0833 26.9167 32.6127 26.9167 30.2221C26.9167 29.0409 27.7763 28.0833 28.9583 28.0833C29.5708 28.0833 30.1833 28.2892 31 29.1127C31.8167 28.2892 32.4292 28.0833 33.0417 28.0833C34.2237 28.0833 35.0833 29.0409 35.0833 30.2221C35.0833 32.6127 31 35.0833 31 35.0833Z"/>' +
    '</svg>';

  /* Once an item is in the bag it has done its job on the wishlist, so it
     comes off — through toggle(), so hearts on the page and the header
     count follow — and the panel re-renders without it. */
  function removeAfterAdd(handle) {
    if (handle && has(handle)) toggle(handle);
    renderPanel();
  }

  /* Instant add for a single-variant item. Same shape as custom.js's
     .feed-add-btn handler (tick on the click, one POST, toast from the
     line it answers with, count reconciled after), but the wishlist panel
     stays open so several saved items can go to the bag in a row — the
     toast's "Change" is there for anyone who wants the cart itself. The
     tick shows for a beat, then the item leaves the wishlist. */
  function addToCart(btn) {
    var variantId = btn.getAttribute('data-wishlist-add-variant');
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = '✓';

    var restore = function () {
      btn.innerHTML = CART_ICON;
      btn.disabled = false;
    };

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);

    fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      })
      .then(function (added) {
        var line = added && added.items ? added.items[0] : added;
        if (window.showCartToastForLine) window.showCartToastForLine(line);
        else if (window.showToast) window.showToast('Added to cart', 'cart');
        setTimeout(function () { removeAfterAdd(btn.getAttribute('data-wishlist-handle')); }, 600);
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { if (window.updateCartCount) window.updateCartCount(cart.item_count); })
          .catch(function () {});
      })
      .catch(function () {
        btn.textContent = '!';
        if (window.showToast) window.showToast('Could not add — try again');
        setTimeout(restore, 1200);
      });
  }


  /* ---------------- Add all to cart ----------------

     The variant each saved product would go into the bag as, or null.
     One variant: that one. Several (sizes): the size the shopper is
     recommended on product pages — their size-quiz answer or the size they
     last picked (assets/vro-pdp-quiz.js) — when the product has it in
     stock. No known size: left for the shopper to pick with the item's own
     bag button, never guessed. */
  /* Does choosing between this product's variants need the shopper? A
     clothing or shoe size, a colour, a fit does — guessing it would put the
     wrong thing in the bag. A pack size or volume (Plum's 50 / 100 / 150ml)
     doesn't: the product page opens on its default, and so does this. */
  var PERSONAL = /size|colou?r|fit|waist|length|width|cup/i;
  function needsChoice(p) {
    return (p.options || []).some(function (o) {
      var name = typeof o === 'string' ? o : (o && o.name) || '';
      if (/^title$/i.test(name)) return false;
      /* "PACK SIZE VALUE" / "PACK SIZE UNIT" are a quantity, not a fit. */
      if (/pack|quantity|qty|weight|volume|count|unit|ml\b/i.test(name)) return false;
      return PERSONAL.test(name);
    });
  }
  function defaultVariant(p) {
    var vs = p.variants || [];
    /* The variant the product page opens on is the first available one. */
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return null;
  }

  function variantFor(p) {
    if (!p || !p.available) return null;
    var vs = p.variants || [];
    if (vs.length === 1) return vs[0].available ? vs[0] : null;
    if (!needsChoice(p)) return defaultVariant(p);
    var rec = null;
    try { rec = window.VroPdpQuiz && window.VroPdpQuiz.recommendFor ? window.VroPdpQuiz.recommendFor(p) : null; } catch (e) { rec = null; }
    if (!rec || rec.index == null) return null;
    for (var i = 0; i < vs.length; i++) {
      var opts = vs[i].options || [vs[i].option1, vs[i].option2, vs[i].option3];
      if (vs[i].available && opts[rec.index] === rec.value) return vs[i];
    }
    return null;
  }

  function paintFooter() {
    if (!footEl || !addAllBtn) return;
    var ready = 0, pick = 0, gone = 0;
    lastProducts.forEach(function (p) {
      if (!p.available) gone++;
      else if (variantFor(p)) ready++;
      else pick++;
    });
    footEl.hidden = ready === 0;
    addAllBtn.disabled = false;
    addAllBtn.textContent = ready === lastProducts.length
      ? 'Add all to cart'
      : 'Add ' + ready + ' item' + (ready === 1 ? '' : 's') + ' to cart';
    var bits = [];
    if (pick) bits.push(pick + ' need' + (pick === 1 ? 's' : '') + ' your size — pick ' + (pick === 1 ? 'it' : 'them') + ' with the bag button');
    if (gone) bits.push(gone + ' sold out');
    if (addAllNote) { addAllNote.textContent = bits.join(' · '); addAllNote.hidden = !bits.length; }
  }

  function addAll() {
    var picks = [];
    lastProducts.forEach(function (p) {
      var v = variantFor(p);
      if (v) picks.push({ handle: p.handle, id: v.id });
    });
    if (!picks.length || addAllBtn.disabled) return;
    addAllBtn.disabled = true;
    addAllBtn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: picks.map(function (x) { return { id: x.id, quantity: 1 }; }) })
    })
      .then(function (res) { if (!res.ok) throw new Error('Add failed'); return res.json(); })
      .then(function () {
        if (window.showToast) window.showToast(picks.length + ' item' + (picks.length === 1 ? '' : 's') + ' added to cart', 'cart');
        /* They are in the bag now, so they leave the wishlist, as a single
           add does (removeAfterAdd). */
        picks.forEach(function (x) { if (has(x.handle)) toggle(x.handle); });
        renderPanel();
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { if (window.updateCartCount) window.updateCartCount(cart.item_count); })
          .catch(function () {});
      })
      .catch(function () {
        if (window.showToast) window.showToast('Could not add — try again');
        paintFooter();
      });
  }

  function renderPanel() {
    var handles = load();
    if (countEl) countEl.textContent = handles.length + ' item' + (handles.length === 1 ? '' : 's');

    if (!handles.length) {
      lastProducts = [];
      paintFooter();
      bodyEl.innerHTML =
        '<div class="wishlist-panel-empty">' +
          '<p>Your wishlist is empty.</p>' +
          '<a href="/" class="wishlist-panel-empty-cta" data-wishlist-panel-close>Continue shopping</a>' +
        '</div>';
      return;
    }

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(Boolean);
      lastProducts = valid;
      paintFooter();
      if (!valid.length) {
        bodyEl.innerHTML = '<div class="wishlist-panel-empty"><p>Your wishlist is empty.</p></div>';
        return;
      }

      var html = '<div class="wishlist-panel-items">';
      valid.forEach(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var price = (p.price / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
        /* Add-to-cart, same three states as the feed card's (+) (snippets/
           feed-product-card.liquid): sold out → disabled; a single variant →
           instant add; real options → the quick-add picker, so we never
           guess a size/colour on the shopper's behalf. */
        var variants = p.variants || [];
        var cartAttrs;
        if (!p.available) {
          cartAttrs = 'disabled aria-label="' + escapeHtml(p.title) + ' is sold out"';
        } else if (variants.length === 1) {
          cartAttrs = 'data-wishlist-add-variant="' + variants[0].id + '" data-wishlist-handle="' + p.handle + '" aria-label="Add ' + escapeHtml(p.title) + ' to cart"';
        } else {
          cartAttrs = 'data-quick-add-handle="' + p.handle + '" aria-label="Choose options for ' + escapeHtml(p.title) + '"';
        }
        html +=
          '<div class="wishlist-panel-item">' +
            '<a href="/products/' + p.handle + '" class="wishlist-panel-item-img">' +
              (img ? '<img src="' + img + '&width=176" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="wishlist-panel-item-info">' +
              '<p class="wishlist-panel-item-vendor">' + escapeHtml(p.vendor) + '</p>' +
              '<a href="/products/' + p.handle + '" class="wishlist-panel-item-title">' + escapeHtml(p.title) + '</a>' +
              '<p class="wishlist-panel-item-price">₹' + price + '</p>' +
              /* Says which rows "Add to cart" leaves out, and why, on the row
                 itself — the line under the button only counted them. */
              (!p.available
                ? '<p class="wishlist-panel-item-note is-soldout">Sold out</p>'
                : (variantFor(p) ? '' : '<p class="wishlist-panel-item-note">Pick your size — tap the bag</p>')) +
            '</div>' +
            '<button type="button" class="wishlist-panel-item-cart" ' + cartAttrs + '>' +
              CART_ICON +
            '</button>' +
            '<button type="button" class="wishlist-panel-item-remove" data-wishlist-toggle="' + p.handle + '" aria-label="Remove from wishlist">' +
              /* The cart panel's own delete (bin) glyph (sections/cart-panel.liquid),
                 cropped to the drawing so it sits the same size in this tile. */
              '<svg width="20" height="20" viewBox="7 10 16 16" fill="none" aria-hidden="true">' +
                '<path d="M19.6667 14.6667V20C19.6667 21.8856 19.6667 22.8284 19.0809 23.4142C18.4951 24 17.5523 24 15.6667 24L14.3333 24C12.4477 24 11.5049 24 10.9191 23.4142C10.3333 22.8284 10.3333 21.8856 10.3333 20L10.3333 14.6667" stroke="#ED7070" stroke-linecap="round" stroke-linejoin="round"/>' +
                '<path d="M21 11.9987L9 11.9987" stroke="#ED7070" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</button>' +
          '</div>';
      });
      html += '</div>';
      bodyEl.innerHTML = html;
    });
  }

  function openPanel() {
    backdrop.hidden = false;
    requestAnimationFrame(function () {
      backdrop.classList.add('is-visible');
      panel.classList.add('is-open');
    });
    panel.removeAttribute('inert');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderPanel();
  }

  function closePanel() {
    backdrop.classList.remove('is-visible');
    panel.classList.remove('is-open');
    panel.setAttribute('inert', '');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { backdrop.hidden = true; }, 320);
  }

  window.VroWishlistPanel = { open: openPanel, close: closePanel };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-panel-open]')) {
      e.preventDefault();
      openPanel();
      return;
    }
    if (e.target.closest('[data-wishlist-panel-close]') || e.target === backdrop) {
      closePanel();
    }
    if (e.target.closest('[data-wishlist-add-all]')) {
      e.preventDefault();
      addAll();
      return;
    }
    var addBtn = e.target.closest('[data-wishlist-add-variant]');
    if (addBtn) {
      e.preventDefault();
      addToCart(addBtn);
      return;
    }
    // Items with real options go through the quick-add picker
    // (assets/quick-add.js, delegated off the same [data-quick-add-handle]
    // as the feed cards). Its Bootstrap modal sits well below this panel's
    // z-index, so the panel steps aside first; this listener is
    // registered before quick-add.js's, so it closes before the modal
    // opens and doesn't undo the modal's scroll lock.
    var quickBtn = e.target.closest('.wishlist-panel-item-cart[data-quick-add-handle]');
    if (quickBtn) {
      pendingQuickAdd = quickBtn.getAttribute('data-quick-add-handle');
      closePanel();
      return;
    }
    if (e.target.closest('.wishlist-panel-item-remove')) {
      setTimeout(renderPanel, 0); // re-render after the generic toggle handler above removes it
    }
  });

  // The picker says when an add went through (assets/quick-add.js). Only
  // the item the picker was opened for from this panel leaves the
  // wishlist — a feed card's (+) on something also wishlisted does not.
  var pendingQuickAdd = null;
  document.addEventListener('vro:quick-add-success', function (e) {
    var handle = e.detail && e.detail.handle;
    if (!handle || handle !== pendingQuickAdd) return;
    pendingQuickAdd = null;
    removeAfterAdd(handle);
  });
  document.addEventListener('click', function (e) {
    // Any other picker opener (a feed card's +) takes over the picker.
    var opener = e.target.closest('[data-quick-add-handle]');
    if (opener && !opener.closest('#wishlistPanel')) pendingQuickAdd = null;
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
  });
});
